<template>
  <div class="row">
    <div class="col-md-8">
      <div class="card card-default">
        <service-wizard-layout
          :title="''"
          :subtitle="''"
          :parts="parts"
          :onComplete="onComplete"
          :validateStep="validateStep"
        >
          <template slot="did">
            <form novalidate data-vv-scope="did">
              <div class="row">
                <div class="col-xl-8 col-lg-12">

                  <div
                    class="form-group"
                    :class="{
                      'has-error': errors.has('did.number'),
                    }"
                  >
                    <label>DID Number</label>
                    <input
                      type="text"
                      class="form-control"
                      v-validate="'required'"
                      name="name"
                      placeholder="DID Number"
                      v-model="filledInSaleDefinition.requiredObjs.didNumber.number"
                    />
                    <span class="has-error" v-if="errors.has('did.number')">{{
                      errors.first("did.number")
                    }}</span>
                  </div>
                  
                </div>
              </div>
            </form>
          </template>
        </service-wizard-layout>
      </div>
    </div>
  </div>
</template>

<script>
import ServiceWizardLayout from "@/layouts/ServiceWizardLayout";

export default {
  components: {
    ServiceWizardLayout,
  },
  props: {
    emptySaleDefinition: {
      type: Object,
      required: true,
    },
  },
  computed: {
  },
  data() {
    return {
      parts: [
        {
          name: "did",
          displayName: "DID Number",
          icon: "fa fa-info",
        },
      ],
      filledInSaleDefinition: {
        supportingEnums: {
          didNumber: {}
        },
        requiredObjs: {
          didNumber: {},
        },
      },
    };
  },
  mounted() {
    this.filledInSaleDefinition = this.emptySaleDefinition;
  },
  methods: {
    onComplete() {
      this.$emit("createSale", this.filledInSaleDefinition);
    },
    validateStep(scope) {
      return this.$validator.validateAll(scope).then((result) => {
        if (result) {
          return true;
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style>
</style>
